import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import empty_prescription from "../../../../assets/images/icons/empty-prescription.svg";
import { GeneralImage } from "../../../../components";
import { EndPoints } from "../../../../Constants/endpoints";
import { useGetData } from "../../../../hooks";
import { GetPatientInfo } from "../../../../interface/GeneralResponse";
import { useToast } from "../../../../Services/ToastContext";
import arrow from "../../../../assets/images/icons/chevron-b.svg";
import PrescriptionDetailsModal from "../../../MyPrescriptions/PrescriptionDetailsModal";

interface PrescriptionCardProp {
  item: any;
  isWithImg?: boolean;
}

const PrescriptionCard: React.FC<PrescriptionCardProp> = ({
  item,
  isWithImg,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const { showToast } = useToast();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  const { data: patientData } = useGetData<GetPatientInfo>(
    EndPoints.GetPatients,
    {},
    id,
  );

  const PatientsData = patientData?.Data;
  const handleEdit = () => {
    if (PatientsData) {
      navigate(`/edit_prescription_of_patient/${PatientsData?.Id}`);
    } else {
      showToast(t("patient_info_not_available"), "error");
    }
  };

  return (
    <div
      className="flex cursor-pointer flex-col items-center rounded-lg bg-InputFieldColor p-3 transition-all"
      onClick={() => {
        isWithImg
          ? setIsOpen(true)
          : navigate(
              `/patients_list/${id}/prescriptions_by_doctors/details/${item?.AccountId}`,
            );
      }}
    >
      <div className="flex w-full items-center gap-2">
        {isWithImg && (
          <GeneralImage
            src={item?.Image}
            alt={
              isWithImg
                ? item?.FullName
                : item?.Specialties && item.Specialties.length > 0
                  ? item.Specialties.map((s: any) => s.SpecialtyName).join(", ")
                  : t("no_specialty")
            }
            width="40px"
            height="40px"
            imageToLoad={empty_prescription}
            className="rounded-full"
          />
        )}
        <div className="flex w-full justify-between">
          <span className="font-bold">
            {isWithImg
              ? item?.FullName
              : item?.Specialties && item.Specialties.length > 0
                ? item.Specialties.map((s: any) => s.SpecialtyName).join(", ")
                : t("no_specialty")}
          </span>
          <span className="text-sm">
            {moment.unix(item?.CreatedAt).format("DD MMM, YYYY")}
          </span>
        </div>
      </div>
      <div className="flex w-full justify-between rounded-md bg-white p-2 text-sm font-bold text-primary">
        <span>{t("view_prescription")}</span>
        <img src={arrow} alt="" className="rtl:rotate-180" />
      </div>
      <PrescriptionDetailsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        prescriptionId={item?.Id}
        onEdit={handleEdit}
        onDeleted={() => {}}
      />
    </div>
  );
};

export default PrescriptionCard;
